import { find, get } from 'lodash';

// For a Coordination Center only, returns the network the user is CC for.
function getCCUserNetwork(user = {}, groupId) {
  const group = find(user.groups, (g) => g.group.id === groupId);
  return find(get(group, 'group.networks', {}), (n) => n.is_coordination_center);
}

export default getCCUserNetwork;
